import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { StoreInterfaces } from "../../../types/store/StoreInterfaces";
import { UserView } from "../../../types/store/SessionStore";
import { setCurrentView } from "../../../store/Session";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export default function ViewSwitcher() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const session = useSelector((state: StoreInterfaces) => state.session);

  if (session.isAdministrator) return null;

  const handleViewChange = (
    _: React.MouseEvent<HTMLElement>,
    value: UserView | null
  ) => {
    if (!value) return;

    dispatch(setCurrentView(value));
    navigate("/home");
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          textTransform: "uppercase",
          fontWeight: "bold",
          mb: 1,
          display: "block",
        }}
      >
        {t("generic.mode")}
      </Typography>

      <ToggleButtonGroup
        exclusive
        fullWidth
        value={session.currentView}
        onChange={handleViewChange}
        size="small"
      >
        <ToggleButton
          value={UserView.BUYER}
          sx={(theme) => ({
            borderRadius: 2,
            border: `1px solid ${theme.palette.divider}`,

            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.main + "30",
              color: theme.palette.primary.main,
              fontWeight: 700,

              "&:hover": {
                backgroundColor: theme.palette.primary.main + "50",
              },
            },

            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
          })}
        >
          {t("generic.buyer")}
        </ToggleButton>

        <ToggleButton
          value={UserView.SUPPLIER}
          sx={(theme) => ({
            borderRadius: 2,
            border: `1px solid ${theme.palette.divider}`,

            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.main + "30",
              color: theme.palette.primary.main,
              fontWeight: 700,

              "&:hover": {
                backgroundColor: theme.palette.primary.main + "50",
              },
            },

            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
          })}
        >
          {t("generic.supplier")}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}